export default "__VITE_ASSET__c2147a35__"